import { CardDetailsModal,
  UpgradeModal,
  CancelDowngradeModal,
  DowngradeModal,
  CancelSubscriptionModal,
  ConfigurePaymentMethodModal,
  ChangePeriodModal,
  ConfirmAutoRenewalModal } from './modals';

export const SubscriptionModals = () => (
  <>
    <UpgradeModal />
    <DowngradeModal />
    <CancelDowngradeModal />
    <CardDetailsModal />
    <CancelSubscriptionModal />
    <ChangePeriodModal />
    <ConfigurePaymentMethodModal />
    <ConfirmAutoRenewalModal />
  </>
);
